/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merry_Clean_Jaguar_PeelInputs */

const en_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credentials loaded`)
};

const id_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredensial dimuat`)
};

const ms_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credentials loaded`)
};

const ca_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credencials carregades`)
};

const cs_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlašovací údaje načteny`)
};

const da_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legitimationsoplysninger indlæst`)
};

const de_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldedaten geladen`)
};

const et_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandaadid laaditud`)
};

const es_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credenciales cargadas`)
};

const fr_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les informations d’identification ont bien été ajoutées.`)
};

const hr_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vjerodajnice učitane`)
};

const it_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credenziali caricate`)
};

const lv_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieteikšanās dati ielādēti`)
};

const lt_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įkelti prisijungimo duomenys`)
};

const hu_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitelesítő adatok betöltve`)
};

const nl_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggegevens geladen`)
};

const nb_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innlogging lastet inn`)
};

const pl_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytano dane uwierzytelniające`)
};

const pt_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas credenciais foram carregadas`)
};

const ro_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acreditări încărcate`)
};

const sk_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Údaje načítané`)
};

const sl_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pooblastila so naložena`)
};

const fi_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääsytiedot ladattu`)
};

const sv_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggningsuppgifter laddade`)
};

const vi_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tải thông tin đăng nhập`)
};

const tr_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik bilgileri yüklendi`)
};

const el_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τα διαπιστευτήρια φορτώθηκαν`)
};

const bg_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данните за вход са заредени`)
};

const ru_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка учетных данных`)
};

const sr_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акредитиви су учитани`)
};

const uk_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облікові дані завантажено`)
};

const ka_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ავტორიზაციის მონაცემები ჩატვირთულია`)
};

const hi_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्रेडेंशियल लोड करें`)
};

const th_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดข้อมูลรับรองแล้ว`)
};

const ko_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로드된 자격 증명`)
};

const zh_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`证书已加载`)
};

const zh_tw_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已載入認證資料`)
};

const ja_merry_clean_jaguar_peel = /** @type {(inputs: Merry_Clean_Jaguar_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証情報が読み込まれました`)
};

/**
* | output |
* | --- |
* | "Credentials loaded" |
*
* @param {Merry_Clean_Jaguar_PeelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const merry_clean_jaguar_peel = /** @type {((inputs?: Merry_Clean_Jaguar_PeelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merry_Clean_Jaguar_PeelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_merry_clean_jaguar_peel(inputs)
	if (locale === "ms") return ms_merry_clean_jaguar_peel(inputs)
	if (locale === "ca") return ca_merry_clean_jaguar_peel(inputs)
	if (locale === "cs") return cs_merry_clean_jaguar_peel(inputs)
	if (locale === "da") return da_merry_clean_jaguar_peel(inputs)
	if (locale === "de") return de_merry_clean_jaguar_peel(inputs)
	if (locale === "et") return et_merry_clean_jaguar_peel(inputs)
	if (locale === "es") return es_merry_clean_jaguar_peel(inputs)
	if (locale === "fr") return fr_merry_clean_jaguar_peel(inputs)
	if (locale === "hr") return hr_merry_clean_jaguar_peel(inputs)
	if (locale === "it") return it_merry_clean_jaguar_peel(inputs)
	if (locale === "lv") return lv_merry_clean_jaguar_peel(inputs)
	if (locale === "lt") return lt_merry_clean_jaguar_peel(inputs)
	if (locale === "hu") return hu_merry_clean_jaguar_peel(inputs)
	if (locale === "nl") return nl_merry_clean_jaguar_peel(inputs)
	if (locale === "nb") return nb_merry_clean_jaguar_peel(inputs)
	if (locale === "pl") return pl_merry_clean_jaguar_peel(inputs)
	if (locale === "pt") return pt_merry_clean_jaguar_peel(inputs)
	if (locale === "ro") return ro_merry_clean_jaguar_peel(inputs)
	if (locale === "sk") return sk_merry_clean_jaguar_peel(inputs)
	if (locale === "sl") return sl_merry_clean_jaguar_peel(inputs)
	if (locale === "fi") return fi_merry_clean_jaguar_peel(inputs)
	if (locale === "sv") return sv_merry_clean_jaguar_peel(inputs)
	if (locale === "vi") return vi_merry_clean_jaguar_peel(inputs)
	if (locale === "tr") return tr_merry_clean_jaguar_peel(inputs)
	if (locale === "el") return el_merry_clean_jaguar_peel(inputs)
	if (locale === "bg") return bg_merry_clean_jaguar_peel(inputs)
	if (locale === "ru") return ru_merry_clean_jaguar_peel(inputs)
	if (locale === "sr") return sr_merry_clean_jaguar_peel(inputs)
	if (locale === "uk") return uk_merry_clean_jaguar_peel(inputs)
	if (locale === "ka") return ka_merry_clean_jaguar_peel(inputs)
	if (locale === "hi") return hi_merry_clean_jaguar_peel(inputs)
	if (locale === "th") return th_merry_clean_jaguar_peel(inputs)
	if (locale === "ko") return ko_merry_clean_jaguar_peel(inputs)
	if (locale === "zh") return zh_merry_clean_jaguar_peel(inputs)
	if (locale === "zh-tw") return zh_tw_merry_clean_jaguar_peel(inputs)
	if (locale === "ja") return ja_merry_clean_jaguar_peel(inputs)
	return en_merry_clean_jaguar_peel(inputs)
});